export function isTelmaMSISDN(msisdnToTest) {
  return (
    /(034|038|036)\d{7}/.test(msisdnToTest || "") &&
    msisdnToTest !== "" &&
    msisdnToTest?.length === 10
  );
}
